import { saveToken, saveUrlToken, saveV2Enabled } from '../../utils/sessionStorage';
import {
  apiInstance,
  configureApiInstance,
  configureOktaApiInstance,
} from '../apiInstance';
import { ApiRoutes } from '../apiRoutes';
import { getArFeaturesAsync } from './features';

export const getUrlToken = () => {
  const urlToken = new URLSearchParams(window.location.search);
  return urlToken.get('t');
};

export const configureInstanceAsync = async (token: string) => {
  await configureApiInstance({ token: token });
};

export const configureOktaInstanceAsync = async (token: string, debtorId: string) => {
  await configureOktaApiInstance({ token: token }, debtorId);
  saveToken(token);
};

export const getTokenAsync = async () => {
  const urlToken = getUrlToken();
  if (urlToken) {
    const path = ApiRoutes.Auth;
    const request = `${path}?token=${urlToken}`;
    const response = await apiInstance.post(request);
    if (response.data) {
      const accessToken = response.data;
      await configureApiInstance({ token: accessToken });
      saveToken(accessToken);
      saveUrlToken(urlToken);
      try {
        const features = await getArFeaturesAsync();
        saveV2Enabled(features.billingReminderV2Enabled);
      } catch {
        saveV2Enabled(false);
      }
    }

    return response;
  }
};
